import { useLoader } from './LoaderContext';
import LoaderOverlay from './Loader';
 
const GlobalLoader: React.FC = () => {
  const { loading, text } = useLoader();
  return <LoaderOverlay active={loading} text={text} />;
};
 
export default GlobalLoader;